import devConfig from './development.json'
import euConfig from './eu.json'
import prodConfig from './production.json'

const localConfigs = {
  QA: devConfig,
  EU: euConfig,
  US: prodConfig,
}

export const isEU = window.DRIFT_REGION === 'EU'

export default {
  ...(window.DRIFT_CONFIG || {}),
  ...localConfigs[
    window.DRIFT_REGION || (window.__ENV__ === 'PRODUCTION' ? 'US' : 'QA')
  ],
}
